export default {
  yokesAccomDef:
    "<p>Yoked accommodation simulates the natural coordination of our eyes <b>by adjusting the focus of both eyes equally</b>. Typically, the eyes will focus just enough to optimize vision in one eye.</p> <p>It's important to note that yoked accommodation may not always provide optimal focus for each eye individually, particularly when there are significant differences in refractive error between the two eyes.</p>  <p><b>When yoked accommodation is disabled, each eye will focus independently.</b> Although this doesn't reflect how eyes normally function, it often proves to be an effective demonstration. This independent focus tends to better align with patients' perceptions of their own vision, as it showcases the potential vision for each eye separately.</p><p><i>Note: Yoked accommodation is only available when both eyes are being viewed in the simulator.</i></p>",

  lookingAtData: {
    far: {
      label: "Distance",
      src: "outside.svg",
      diopters: 0,
      icon: "tree",
      shortDistance: "20+ feet (6m)",
      distance: "looking 20 feet and beyond",
      distance_metric: "looking 6 meters and beyond",
      description: "looking at distance",
      left: 13,
    },
    wall: {
      label: "Room",
      src: "tv.svg",
      diopters: 0.45,
      icon: "image-frame",
      shortDistance: "7-8 feet (2.2m)",
      distance: "looking across a room 7-8 feet away",
      distance_metric: "looking across a room 2.2 meters away",
      description: "looking across a room",
      left: 40,
    },
    intermediate: {
      label: "Computer",
      src: "computer.svg",
      diopters: 1.25,
      icon: "monitor",
      shortDistance: "32in (80cm)",
      distance: 'looking at a computer about 32" away',
      distance_metric: "looking at a computer 80cm away",
      description: "looking at a computer",
      left: 70,
    },
    near: {
      label: "Phone/Book",
      src: "phone.svg",
      diopters: 2.5,
      icon: "cellphone",
      shortDistance: "16in (40cm)",
      distance: 'reading something 16" away',
      distance_metric: "reading something 40cm away",
      description: "looking at a phone",
      left: 80,
    },
    nearer: {
      label: "Needle",
      src: "thread_needle.svg",
      diopters: 5,
      image: "needle_icon.svg",
      shortDistance: "8in (20cm)",
      distance: 'looking at something about 8" away',
      distance_metric: "looking at something about 20cm away",
      description: "looking at a needle",
      left: 90,
    },
  },
  generalInfo: [
    "The best vision will be achieved when all the light is able to focus on the back wall of the eye (the retina).",
    "In <b>myopia</b> (nearsightedness), light will focus <i>in front of</i> the retina",
    "In <b>hyperopia</b> (farsightedness), light focuses <i>behind</i> the retina.",
    "In an eye with <b>astigmatism</b> light will focus at different points",
    "<b>Accommodation</b> is focusing. People younger than 40 years old can accommodate to compensate for uncorrected hyperopia or to see better up close.",
    "<b>Presbyopia</b> is an age related change where the lens in the eye becomes less flexible and and it becomes more difficult to accommodate.",
  ],
  accommodationDef:
    "<img src='https://www.eyedock.com/images/visionSimulator/accommodation.svg' style='width: 100%;max-width: 450px;'/><p>The eye accommodates (focuses on near objects) when the ciliary muscles contract to allow the lens to become more convex, increasing its refractive power to bend light rays from close objects onto the retina.</p><p>This ability naturally declines with age (presbyopia) as the lens becomes less elastic and the ciliary muscles weaken, typically becoming noticeable around age 40-45 when people start having difficulty focusing on near objects like books or phones.</p>",
};
